export default __webpack_public_path__ + "static/freeze-2028d59a2a411adcf8d8c0b5a7fcbeba.svg";